'use strict';

var takeUntil = require('./takeUntil');
var complement = require('../functional/complement');

module.exports = function (input, fn) {
  return takeUntil(input, complement(fn));
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/takeWhile.js
// module id = 2186
// module chunks = 37